var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47059 14V12.7308H4.70588L5.88988 8.5758C5.96983 8.30198 6.11846 8.07986 6.33578 7.90946C6.5531 7.73905 6.79662 7.65385 7.06632 7.65385H8.93368C9.20338 7.65385 9.4469 7.73905 9.66422 7.90946C9.88154 8.07986 10.0302 8.30198 10.1101 8.5758L11.2941 12.7308H12.5294V14H3.47059ZM5.99265 12.7308H10.0074L8.92647 8.92308H7.07353L5.99265 12.7308ZM7.38235 6.38462V3H8.61765V6.38462H7.38235ZM11.0539 7.9359L10.1789 7.05449L12.5123 4.65705L13.3873 5.55609L11.0539 7.9359ZM11.7059 10.8269V9.55769H15V10.8269H11.7059ZM4.94608 7.95353L2.61275 5.55609L3.48775 4.65705L5.80392 7.05449L4.94608 7.95353ZM1 10.8269V9.55769H4.29412V10.8269H1Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/Risk.2930be8eb703d799bccf51a0a6929851.svg";
export { ForwardRef as ReactComponent };